export type MissionLike = Record<string, unknown>

function appendSignerId(signerIds: string[], value: unknown) {
  if (typeof value !== 'string' && typeof value !== 'number') return
  const signerId = String(value)
  if (signerId && !signerIds.includes(signerId)) {
    signerIds.push(signerId)
  }
}

function appendSignerIds(signerIds: string[], value: unknown) {
  if (Array.isArray(value)) {
    value.forEach((item) => appendSignerId(signerIds, item))
    return
  }
  appendSignerId(signerIds, value)
}

function appendSignerObjectId(signerIds: string[], value: unknown) {
  if (!value || typeof value !== 'object') return
  appendSignerId(signerIds, (value as { id?: unknown }).id)
}

export function getCompanySignatureSignerIds(
  mission: MissionLike | null | undefined
): string[] {
  const signerIds: string[] = []
  if (!mission) return signerIds

  appendSignerIds(signerIds, mission.companySignatureSignerIds)
  appendSignerIds(signerIds, mission.company_signature_signer_ids)
  appendSignerId(signerIds, mission.companySignatureSignerId)
  appendSignerId(signerIds, mission.company_signature_signer_id)
  appendSignerObjectId(signerIds, mission.companySignatureSigner)
  appendSignerObjectId(signerIds, mission.company_signature_signer)
  appendSignerObjectId(signerIds, mission.team_signer)
  appendSignerId(signerIds, mission.team_signer_id)
  appendSignerObjectId(signerIds, mission.teamSigner)

  return signerIds
}

export function isCompanySignatureSignerForMission(
  mission: MissionLike | null | undefined,
  userId: string | null | undefined
): boolean {
  if (!mission || !userId) return false
  return getCompanySignatureSignerIds(mission).some((signerId) => signerId === String(userId))
}

type SignerProfileLike = {
  id?: string
  first_name?: string | null
  last_name?: string | null
  name?: string | null
}

/** Resolve company signatory for a mission document row (MA signer ≠ mission team_signer). */
export function resolveDocumentTeamSigner(
  document: { teamSignerId?: string | null; teamSigner?: SignerProfileLike | null } | null | undefined,
  missionTeamSigner: SignerProfileLike | null | undefined,
  companySignatureSigners: SignerProfileLike[] | null | undefined
): SignerProfileLike | null {
  if (document?.teamSigner?.id || document?.teamSigner?.first_name || document?.teamSigner?.name) {
    return document.teamSigner
  }

  const signerId =
    document?.teamSignerId != null && document.teamSignerId !== ''
      ? String(document.teamSignerId)
      : null

  if (signerId) {
    const fromMissionSigners = (companySignatureSigners ?? []).find(
      (profile) => profile?.id != null && String(profile.id) === signerId
    )
    if (fromMissionSigners) return fromMissionSigners

    if (missionTeamSigner?.id && String(missionTeamSigner.id) === signerId) {
      return missionTeamSigner
    }
  }

  return missionTeamSigner ?? null
}

export function formatSignerDisplayName(signer: SignerProfileLike | null | undefined): string {
  if (!signer) return ''
  if (signer.first_name && signer.last_name) {
    return `${signer.first_name} ${signer.last_name}`.trim()
  }
  return (signer.name ?? '').trim()
}
